import React from 'react';
import './PaymentOptions.styles.scss';
import useTranslation from '../../../translations/use-translation';

const PaymentOptions = () => {
  const translate  = useTranslation();
  return (
    <div className="payment-options">
      <h2>{translate('PAYMENT_OPTIONS')}</h2>
      <div>
        <input type="radio" id="cod" name="payment" value="cod" />
        <label htmlFor="cod">{translate('CASH_ON_DELIVERY')}</label>
      </div>
      <div>
        <input type="radio" id="credit" name="payment" value="credit" />
        <label htmlFor="credit">{translate('CREDIT_CARD')}</label>
      </div>
      <div>
        <input type="radio" id="debit" name="payment" value="debit" />
        <label htmlFor="debit">{translate('DEBIT_CARD')}</label>
      </div>
      <div>
        <input type="radio" id="netbanking" name="payment" value="netbanking" />
        <label htmlFor="netbanking">{translate('NET_BANKING')}</label>
      </div>
    </div>
  );
}

export default PaymentOptions;
